import {WithFormControl} from '../utils';
import {Component, Input} from '@angular/core';
import {Field} from '../../../k2-forms-state/types';
import {Client} from '../../../entities-state/types';

@Component({
  selector: 'clients-control',
  templateUrl: 'clients-control.component.html',
  standalone: false
})
export class ClientsControlComponent extends WithFormControl<number[]> {
  @Input() field: Field<number[]>;

  get clients(): Client[] {
    return this.field.attributes.valueOptions;
  }
}
